export default __webpack_public_path__ + "static/media/personalization.60f72b0b.svg";